<template>
  <img
    :src="icon"
    :alt="alt"
    :height="height"
    :class="iconClass"
    :style="iconStyle"
    @click.stop="confirmAction"
  />
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "ConfirmAction",
  props: {
    icon: {
      type: String,
      default: require("@/assets/icons/trash-w.svg"),
    },
    alt: {
      type: String,
      default: "Confirm",
    },
    height: {
      type: [String, Number],
      default: 25,
    },
    iconClass: {
      type: String,
      default: "me-2",
    },
    iconStyle: {
      type: String,
      default: "cursor: pointer;",
    },
    title: {
      type: String,
      default: "Confirmation",
    },
    text: {
      type: String,
      default: "Cette action est irréversible. Voulez-vous continuer ?",
    },
    confirmText: {
      type: String,
      default: "Oui, supprimer",
    },
    cancelText: {
      type: String,
      default: "Annuler",
    },
    confirmColor: {
      type: String,
      default: "#ef4444", // Modern Red (Tailwind red-500)
    },
  },
  methods: {
    confirmAction() {
      Swal.fire({
        title: this.title,
        text: this.text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.confirmText,
        cancelButtonText: this.cancelText,
        // --- CUSTOM DESIGN LOGIC ---
        customClass: {
          container: 'swal-container',
          popup: 'swal-popup',
          title: 'swal-title',
          htmlContainer: 'swal-text',
          confirmButton: 'swal-confirm-btn',
          cancelButton: 'swal-cancel-btn',
        },
        buttonsStyling: false, // This disables default Swal styles to use our CSS
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit("confirm");
        }
      });
    },
  },
};
</script>

<style scoped>
/* Only styles for the trigger icon */
img {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
img:hover {
  opacity: 0.7;
  transform: scale(1.1);
}
</style>


<style>

/* --- MODERN SWAL REDESIGN --- */

/* Background Overlay */
.swal-container {
  font-family: 'Inter', sans-serif !important;
}

/* The Popup Card */
.swal-popup {
  border-radius: 16px !important;
  padding: 2rem !important;
  background-color: #ffffff !important;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
}

/* Title Styling */
.swal-title {
  color: #1e293b !important; /* Slate 800 */
  font-size: 20px !important;
  font-weight: 700 !important;
  padding-bottom: 10px !important;
}

/* Text Styling */
.swal-text {
  color: #64748b !important; /* Slate 500 */
  font-size: 15px !important;
  line-height: 1.5 !important;
}

/* Generic Button Base */
.swal-confirm-btn, .swal-cancel-btn {
  padding: 10px 24px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  transition: all 0.2s ease !important;
  border: none !important;
  cursor: pointer !important;
  margin: 5px !important;
}

/* Confirm Button (Red/Danger) */
.swal-confirm-btn {
  background-color: #ef4444 !important; /* red-500 */
  color: white !important;
}

.swal-confirm-btn:hover {
  background-color: #dc2626 !important; /* red-600 */
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(239, 68, 68, 0.4);
}

/* Cancel Button (Neutral/Slate) */
.swal-cancel-btn {
  background-color: #f1f5f9 !important; /* slate-100 */
  color: #475569 !important; /* slate-600 */
}

.swal-cancel-btn:hover {
  background-color: #e2e8f0 !important; /* slate-200 */
  color: #1e293b !important;
}

/* Warning Icon Animation Fix */
.swal2-icon.swal2-warning {
  border-color: #f59e0b !important; /* Amber 500 */
  color: #f59e0b !important;
}
</style>